import { React, useState, useEffect } from "react";
import { BASE_URL } from "../env";
import style from "../Assets/css/adminSlider.module.css";
import { store } from "react-notifications-component";

function AdminSlider() {
	const [testTitle, setTestTitle] = useState("");
	const [testCode, setTestCode] = useState("");
	const [testDuration, setTestDuration] = useState("");
	const [testMarks, setTestMarks] = useState("");
	const [testLink, setTestLink] = useState("");
	const [testDate, setTestDate] = useState("");
	const [testSlot, setTestSlot] = useState("");
	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState("");
	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	const EnrollingTheUser = async () => {
		// console.log("hi");
		const notifyPopup = () => {
			store.addNotification({
				title: "Success!",
				message: "Form Submitted Successfully!",
				type: "success",
				background: "pink",
				insert: "bottom",
				container: "bottom-right",
				animationIn: ["animate__animated", "animate__fadeIn"],
				animationOut: ["animate__animated", "animate__fadeOut"],
				dismiss: {
					duration: 3000,
					onScreen: true,
				},
			});
		};

		const data = {
			name: testTitle,
			eventCode: testCode,
			duration: testDuration,
			marks: testMarks,
			iframeLink: testLink,
			timeFrame: testSlot,
			courseId: course,
			test_date: testDate,
		};

		await fetch(BASE_URL + "/createSlido", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify(data),
		})
			.then((res) => res.json())
			.then((data) => {
				notifyPopup();
				console.log(data);
			});
	};

	return (
		<>
			<div className={style.adminSliderPage}>
				<div className={style.adminSliderCard}>
					<div className={style.adminSliderCardHeading}>
						Admin Slider
					</div>
					<form
						className={style.adminSliderform}
						onSubmit={EnrollingTheUser}
					>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test title"
							value={testTitle}
							onChange={(e) => {
								setTestTitle(e.target.value);
							}}
						/>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test code"
							value={testCode}
							onChange={(e) => {
								setTestCode(e.target.value);
							}}
						/>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test duration"
							value={testDuration}
							onChange={(e) => {
								setTestDuration(e.target.value);
							}}
						/>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test marks"
							value={testMarks}
							onChange={(e) => {
								setTestMarks(e.target.value);
							}}
						/>
						<input
							type="text"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test link"
							value={testLink}
							onChange={(e) => {
								setTestLink(e.target.value);
							}}
						/>
						<input
							type="date"
							className={`form-control ${style.adminSliderCardField}`}
							placeholder="Enter test code"
							value={testDate}
							onChange={(e) => {
								setTestDate(e.target.value);
							}}
						/>
						<select
							className={`form-control ${style.adminSliderCardField}`}
							aria-label="Default select example"
							value={testSlot}
							onChange={(e) => {
								setTestSlot(e.target.value);
							}}
						>
							<option selected>Select Time slot</option>
							<option value="morning">Morning</option>
							<option value="afternoon">Afternoon</option>
							<option value="evening">Evening</option>
						</select>
						<select
							className={`form-control ${style.adminSliderCardField}`}
							aria-label="Default select example"
							name=""
							id=""
							value={course}
							onChange={(e) => {
								setcourse(e.target.value);
							}}
						>
							<option value="">Select Course</option>
							{courses.map((val) => {
								return (
									<option value={val?._id}>
										{val?.name}
									</option>
								);
							})}
						</select>
						<button
							type="submit"
							className={`btn ${style.adminSliderFormBtn}`}
						>
							Submit
						</button>
					</form>
				</div>
			</div>
		</>
	);
}

export default AdminSlider;
